<template>
  <div class="change-password-wrap">
    <p>{{fullName}}</p>

    <div class="input-wrap">
      <label for="">{{$t('adminUserManagement.newPassword')}}</label>
      <input type="password" v-model="newPassword" :class="newPasswordErrors.length !== 0? 'hasError' : ''">
      <div class="errors" v-if="newPasswordErrors.length !== 0">
        <label v-for="error in newPasswordErrors" :key="error" class="error" for="name">{{error}}</label>
      </div>
    </div>
    <div class="input-wrap">
      <label for="">{{$t('adminUserManagement.confirmNewPassword')}}</label>
      <input type="password" v-model="confirmNewPassword" :class="confirmNewPasswordErrors.length !== 0? 'hasError' : ''">
      <div class="errors" v-if="confirmNewPasswordErrors.length !== 0">
        <label v-for="error in confirmNewPasswordErrors" :key="error" class="error" for="name">{{error}}</label>
      </div>
    </div>
    
    <div class="buttons">
      <button class="change-button" @click="changePassword">{{$t('button.changePassword')}}</button>
      <button class="cancel-button" @click="$emit('close-modal')">{{$t('button.cancel')}}</button>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import AdminMixin from '@/views/admin-pages/adminMixin.js';
export default {
  mixins: [
    AdminMixin
  ],
  props: {
    userId: Number,
    fullName: String
  },
  data () {
    return {
      newPassword: '',
      newPasswordErrors: [],
      confirmNewPassword: '',
      confirmNewPasswordErrors: []
    }
  },
  methods: {
    async changePassword () {
      if (this.hasErrors()) {
        return;
      }
      try {
        this.startLoading()
        await api.changeUserPassword({
          usr_id: this.userId,
          password: this.newPassword
        })
        this.$emit('close-modal');
        this.showSuccessMessage(this.$t('adminUserManagement.success'));
      } catch (error) {
        this.handleError(error);
      }
      this.stopLoading();
    },
    hasErrors () {
      this.clearErrors();
      this.validateNewPassword();
      this.validateConfirmNewPassword();

      if (this.newPasswordErrors.length !== 0 || this.confirmNewPasswordErrors.length !== 0) {
        return true;
      } else {
        return false;
      }
    },
    clearErrors () {
      this.newPasswordErrors = [];
      this.confirmNewPasswordErrors = [];
    },
    validateNewPassword () {
      if (this.newPassword === '') {
        this.newPasswordErrors.push(this.$t('register.passwordEmptyError'))
      }

      if (this.newPassword.length < 8) {
        this.newPasswordErrors.push(this.$t('register.passwordError'))
      }
    },
    validateConfirmNewPassword () {
      if (this.confirmNewPassword === '') {
        this.confirmNewPasswordErrors.push(this.$t('register.confirmPasswordEmptyError'))
      }

      if (this.newPassword !== this.confirmNewPassword) {
        this.confirmNewPasswordErrors.push(this.$t('register.confirmPasswordError'))
      }
    },
    bindChangePasswordOnEnter(e){
      if (e.keyCode === 13) { 
          this.changePassword();
      }
    }
  },
  mounted(){
      window.addEventListener('keyup', this.bindChangePasswordOnEnter);
  },
  destroyed(){
      window.removeEventListener('keyup', this.bindChangePasswordOnEnter);
  }
}
</script>

<style scoped>
.change-password-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.buttons {
  display:flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 10% 0;
}
.buttons button {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border: none;
  padding: 10px;
  border-radius: 100px;
  font-size: 16px;
  height: 40px;
  width: 70%;
}
.change-button {
  background: var(--button-color-blue);
  color:white;
  margin-bottom: 3%;
}
.buttons button:active, .buttons button:focus {
  outline:none;
  border:none;
}
.input-wrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 70%;
  margin-bottom: 2%;
}
label {
  font-size: 0.7em;
}
.input-wrap input.hasError {
  border: 1.5px solid red;
}
.error {
  color: red;
  font-size: 0.5em
}
.errors {
  display: flex;
  flex-direction: column;
  margin: 0;
}
</style>